import { SearchOutlined } from "@ant-design/icons";
import { images } from "../assets";

export default function SupportPage() {
  return (
    <div className="w-full">
      <div className="flex sm:gap-x-[30px] justify-center  flex-col sm:flex-row shadow-lg bg-white rounded-[10px]">
        <div className="flex flex-col mt-8 sm:ml-7 sm:mb-[65px] mb-3 gap-y-3 sm:gap-y-[21px]">
          <span className="text-2xl sm:text-xl mx-auto sm:mx-0  font-bold leading-8 text-[#119AE2]">
            SPHACY CÓ THỂ GIÚP GÌ BẠN?
          </span>
          <div className="flex w-[full] mx-2 sm:mx-0 sm:w-[733px] py-2 font-normal rounded items-centertext-base bg-gray">
            <input
              className="flex w-full bg-transparent sm:flex-1 mx-7"
              placeholder="Nhập từ khoá nội dung cần tìm"
            ></input>
            <SearchOutlined className="mr-4 text-lg text-main-blue" />
          </div>
        </div>
        <div className="flex flex-1">
          <img src={images.support} alt="" />
        </div>
      </div>
      <h3 className="text-lg not-italic font-extrabold capitalize my-[20px]">
        CÂU HỎI THƯỜNG GẶP
      </h3>
      <div className="flex flex-col flex-1 w-full sm:flex-row gap-y-1">
        <div className="flex flex-1 flex-col shadow-lg bg-white rounded-[10px]">
          <div className="flex flex-col gap-y-[12px] p-5 ">
            <div className="flex flex-col gap-y-[8px]  mb-3">
              <span className="text-sm font-normal text-[#222222] mb-3">
                • Quy trình trả hàng hoàn tiền
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
              <span className="text-sm font-normal text-[#222222] mt-4 mb-3">
                • Cách theo dõi tình trạng vận chuyển của đơn hàng?
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
              <span className="text-sm font-normal text-[#222222] mt-3">
                • LÀM SAO ĐỂ MUA HÀNG/ ĐẶT HÀNG TRÊN ỨNG DỤNG SPHACY?
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
            </div>
          </div>
        </div>
        <div className="w-4"></div>
        <div className="flex flex-1 flex-col shadow-lg bg-white rounded-[10px]">
          <div className="flex flex-col gap-y-[12px] p-5 ">
            <div className="flex flex-col gap-y-[8px]  mb-3">
              <span className="text-sm font-normal text-[#222222] mb-3">
                • Quy trình trả hàng hoàn tiền
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
              <span className="text-sm font-normal text-[#222222] mt-4 mb-3">
                • Cách theo dõi tình trạng vận chuyển của đơn hàng?
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
              <span className="text-sm font-normal text-[#222222] mt-3">
                • LÀM SAO ĐỂ MUA HÀNG/ ĐẶT HÀNG TRÊN ỨNG DỤNG SPHACY?
              </span>
              <div className="w-full h-[1px] bg-[#D9D9D9]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
